class AppManagerCtrl {
  constructor( $scope, $sce, $window, $timeout, SchemaService, FEService, FlashService, AuthService, EventService, TemplateService) {
    'ngInject';
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.ss = SchemaService;
    this.ts = TemplateService;
    this.es = EventService;
    this.fs = FlashService;
    this.fe = FEService;
    this.as = AuthService;

    this.loading = "Loading...";
    this.initializing = true;
    this.updating = false;
    this.updating = false;
    this.isValid = false;
    this.connectionSelected = false;
    this.messages = [];
    this.prompts = [];
    this.conns = [];
    this.appFilter = '';
    this.selectedConnIndex = null;

    this.connColumns = [
      {
        'key': 'formattedName',
        'header': 'Name',
        'sortable': true,
        'tooltip': false,
      }, 
      {
        'key': 'createdByName',
        'header': 'Owner',
        'sortable': true,
        'tooltip': true,
        'style': {"max-width": "150px", "width": "150px", "vertical-align": "middle"},
        'format': (value) => { return value }
      }, 
      { 
        'header': 'Date', 
        'key': 'createdAt', 
        'style': {"max-width": "80px", "width": "80px", "vertical-align": "middle"},
        'format': (value) => new Date(value).toLocaleDateString("en-US")
      }
    ];
  }

  async $onInit(){
    try {
      const [td, granted, PROVIDER, realm] = await Promise.all([
        this.template ? this.fe.waitForBindings(["template"], this.$scope): this.ts.getTemplateData(),
        this.ss.getGrantedDBs(),
        this.as.getProviderSettings(),
        this.as.realm()
      ]);

      this.PROVIDER = PROVIDER;
      this.realm = realm;
      this.conns = await this.loadRealmConns();
      this.initializing = false;
      this.td = this.template ? { template: this.template } : td;
      this.templateId = this.template ? this.template.id : this.ts.templateId;
      this.apps = granted.filter(g => !g.tableName);
      const appId = this.td.template?.appId;
      this.preloadPrompts();
      
      if (!appId && !this.templateId){
        this.showAppPanel = true;
        this.connectionIsValid = false;
        this.setMessages([{"message": "Please select an Application"}], "alert-info");
      } else {
        appId && this.setSelectedApp(this.apps.find(app => app.appId === appId));
        await this.validateAppConnection(this.td.template);
      }
      if (this.template.connectionId) this.$timeout(_ => this.selectedConnId = this.template.connectionId);
    } catch (error) {
      console.error(error);
      this.fs.error(error);
    }
  }

  async loadRealmConns() {
    this.loading = "Loading...";
    const response = await this.ss.getRealmConnections({includeTemplates: false});
    const { "data": { connections } } = response;
    connections.forEach(c => {
      const propertyLabel = this.ts.getConnLabel(this.PROVIDER.connPropLabels, c.properties);
      const connPropsLabel = `<span class="help-block small text-muted conn-label">${propertyLabel}</span>`;
      c.formattedName = c.name + connPropsLabel;
    });
    return connections;
  }
  
  async validateAppConnection(template, promptValues = [], initPrompts = []){
    this.loading = "Checking...";
    this.connectionIsValid = undefined;
    this.setMessages(); // Clear current messages;
    const promptVals = promptValues.length ? promptValues : initPrompts;
    const response = await this.ss.validConnection(template, promptVals, this.ignoreStoredConn);
    const { "data": { isValid, appId, prompts, requireAPrompt, promptInfo, errorMessages = [] } } = response;
    if (!this.template.appId) { // Used for invalid stored connections
      this.template.appId = appId;
      this.setSelectedApp(this.apps.find(app => app.appId === appId));
    }
    this.$timeout(() => {
      Object.assign(this, { isValid, prompts, loading: "", requireAPrompt, promptInfo } );
      initPrompts.length && this.setOriginalPrompts(initPrompts);
      this.setMessages(errorMessages);
      this.connectionIsValid = isValid;
    });
    return isValid;
  }

  newConnection = () => this.newConn = true;
 
  setMessages(msgs = [], type="alert-danger"){
    this.messages = msgs.map(m => ({"message": m.message, "class": type}));
  }

  setOriginalPrompts(initPrompts) {
    initPrompts.forEach(p => {
      if (p.response) {
        const i = this.prompts.findIndex(pa => pa.key == p.key);
        this.prompts[i].response = p.response;
      }
    });
  }

  hasPrompts() {
    return this.selectedApp && this.prompts.length > 0;
  }

  hasConns() {
    return this.selectedApp && this.conns.length > 0;
  }

  async selectConn(conn) {
    if (this.template.connectionId == conn.id) return;
    this.connectionSelected = true;
    const valid = await this.validateAppConnection({appId: this.selectedApp.appId, connectionId: conn.id});
    if (!valid) return;
    
    this.template.connectionId = conn.id;
    this.selectedConnId = conn.id;
    if (this.templateId) {
      if (!confirm(`Do you want to apply "${conn.name}" as the template's connection?`)) return;
      this.$timeout(_ => this.loading = "Updating template connection...");
      try {
        const newConnId = await this.ts.saveConnection(this.template, [], false);
        if (!newConnId) {
          this.setMessages([{"message": "There was an error updating the connection!"}]);
          this.$timeout(_ => this.loading = "");
          return;
        }
        this.fs.success("Reloading template...");
        this.ignoreLeaveConfirm = true;
        this.$timeout(() => {
          this.$window.location.reload();
          return;
        }, 500);
      }
      catch {
        this.fs.error('There was an error loading the template!');
        this.loading = "";
      }
    }
  }

  // Load previous unencrypted values when updating a conn, so user doenst have to retype
  preloadPrompts() {
    const promptValues = this.ts.getNewConnection(promptValues);
  }

  // Check if any missing required prompt to disable button
  hasMissingPrompts() {
    const hasRequiredPrompts = this.prompts.every(prompt => !prompt.required || (prompt.required && prompt.response));
    // If requireAPrompt, at least one optional prompt must be supplied
    if (this.requireAPrompt) return !(hasRequiredPrompts && this.prompts.some(prompt => !prompt.required && prompt.response));
    return !hasRequiredPrompts;
  }
  
  async setConnection(selectedApp, promptValues){
    this.connectionSelected = true;
    // New templates without required conn prompts don't need to create a connection
    if (!this.templateId && !promptValues.some(p => p.response)) {
      this.connectionIsValid = null; // force parent $watch
      this.$timeout(_ => this.connectionIsValid = true);
      return;
    }
    this.updating = true;
    this.loading = "Saving...";
    this.setMessages(); // Clear current messages;

    this.setTemplateAppId(selectedApp); // Trigger $digest

    const valid = await this.validateAppConnection(this.td.template, promptValues);
    if (!valid) {
      this.updating = false;
      return;
    }

    this.ts.setNewConnection(promptValues);
    if (this.templateId) {
      // Template is null when stored conn is invalid, use in-memory template instead
      const template = this.ts.toRaw() || this.td.template;
      template.connectionId = null;
      const newConnId = await this.ts.saveConnection(template, promptValues, true);
      if (!newConnId) {
        this.setMessages([{"message": "There was an error updating the connection!"}]);
        this.updating = false;
        return;
      }
      this.fs.success("Reloading template...");
      this.ignoreLeaveConfirm = true;
      this.$timeout(() => {
        this.$window.location.reload();
        return;
      }, 500);
    }
    else if (this.connectionId) {
      this.loading = "Saving connection...";
      this.updating = true;
    }
    else this.updating = false;
  }

  sceHtml(html){
    return this.$sce.trustAsHtml(html);
  }
  
  async selectApp(app) {
    if (this.selectedApp && app.appId === this.td.template.appId) return;
    if (this.PROVIDER.handleAppsIndependently && this.templateId) {
      const confirmMessage = "Selecting a new app will result in the loss of ALL form data currently associated width this template. \nAre you sure you wish to choose a new app for this template?";
      if(this.td.template.appId && !this.$window.confirm(confirmMessage)){
        return;
      }
    }
    
    this.connectionSelected = false;
    this.setTemplateAppId(app);
    await this.validateAppConnection(app, [], this.initPrompts);
    this.setSelectedApp(app);
    this.$scope.$apply();
  }

  setSelectedApp(app) {
    this.selectedApp = app;
    this.selectedApp.link = this.PROVIDER.appLinkTemplate
      .replace("[REALM]", this.realm)
      .replace("[APP_ID]", app.appId);
  }

  setTemplateAppId(app){
    let newValues = {};

    if (this.PROVIDER.handleAppsIndependently && !this.connectionId) { 
      newValues.connectionId = '';
      this.td.template.connectionId = ''; 
    }
    this.td.template.appId = app.appId;
    newValues.appId = app.appId;

    this.ts.notifyUpdate(
      ["appId", "connectionId",],
      { template: { ...newValues }});
  }

  filterApps(appFilter) {
    return (item) => {
      return item.appName.toLowerCase().includes(appFilter.toLowerCase()) || this.td?.template?.appId === item.appId;
    };
  }
}

export default {
  bindings: {
    connectionIsValid: "=",
    connectionSelected: "=?",
    template: "=",
    ignoreStoredConn: "=?",
    ignoreLeaveConfirm: "=?",
    updating: "=?",
    showBack: "=?",
    connectionId: "=?",
    prompts: "=?",
    initPrompts: "=?"
  },
  templateUrl: 'schema/app-manager/app-manager.component.html',
  controller: AppManagerCtrl
};